function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 0a20 20 0 100 40 20 20 0 000-40zm0 37.8a17.8 17.8 0 110-35.6 17.8 17.8 0 010 35.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 13c-.5 0-1 .1-1.3.3-.7.5-1.2 1.3-1.2 2.2v9c0 1 .5 1.7 1.2 2.2.8.4 1.7.4 2.5 0l8-4.6c.8-.4 1.3-1.2 1.3-2.1 0-1-.5-1.7-1.3-2.1l-8-4.6-1.2-.3zm-.2 2.1h.4l8 4.6.1.3c0 .2 0 .3-.2.3L17.7 25h-.3l-.2-.4v-9l.1-.4z"
});

function SvgOPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOPlay);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+CiAgPHBhdGggZD0iTTIwIDBhMjAgMjAgMCAxMDAgNDAgMjAgMjAgMCAwMDAtNDB6bTAgMzcuOGExNy44IDE3LjggMCAxMTAtMzUuNiAxNy44IDE3LjggMCAwMTAgMzUuNnoiIC8+CiAgPHBhdGggZD0iTTE3LjUgMTNjLS41IDAtMSAuMS0xLjMuMy0uNy41LTEuMiAxLjMtMS4yIDIuMnY5YzAgMSAuNSAxLjcgMS4yIDIuMi44LjQgMS43LjQgMi41IDBsOC00LjZjLjgtLjQgMS4zLTEuMiAxLjMtMi4xIDAtMS0uNS0xLjctMS4zLTIuMWwtOC00LjYtMS4yLS4zem0tLjIgMi4xaC40bDggNC42LjEuM2MwIC4yIDAgLjMtLjIuM0wxNy43IDI1aC0uM2wtLjItLjR2LTlsLjEtLjR6IiAvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };